export async function hashPin(pin: string): Promise<string> {
  return pin;
}

/**
 * PIN 입력값 유효성 검사 (정확히 4자리 숫자)
 */
export function isValidPin(pin: string): boolean {
  return /^\d{4}$/.test(pin);
}
